import React, { createContext, useContext } from 'react';
import { FetchPendingSection2ItemsUseCase } from '../../application/use-cases/FetchPendingSection2ItemsUseCase';
import { ApiPendingSection2Repository } from '../repositories/ApiPendingSection2Repository';
import { useHttpClientCore } from '@/shared';
import { ArchiveI9UseCase } from '@/shared/application/use-cases/ArchiveI9UseCase';
import { ApiArchiveI9Repository } from '@/shared/infra/repositories/ApiArchiveI9Repository';

interface IPendingSection2DIContext {
  fetchPendingSection2ItemsUseCase: FetchPendingSection2ItemsUseCase;
  archiveI9UseCase: ArchiveI9UseCase;
}

const PendingSection2DIContext = createContext<IPendingSection2DIContext | undefined>(undefined);

export const PendingSection2DIProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const httpClient = useHttpClientCore();
  const repository = new ApiPendingSection2Repository(httpClient);
  const fetchPendingSection2ItemsUseCase = new FetchPendingSection2ItemsUseCase(repository);
  const archiveI9UseCase = new ArchiveI9UseCase(new ApiArchiveI9Repository(httpClient));

  return (
    <PendingSection2DIContext.Provider
      value={{ fetchPendingSection2ItemsUseCase, archiveI9UseCase }}
    >
      {children}
    </PendingSection2DIContext.Provider>
  );
};

export function usePendingSection2DIContext() {
  const ctx = useContext(PendingSection2DIContext);
  if (!ctx) throw new Error('usePendingSection2DIContext must be used within PendingSection2DIProvider');
  return ctx;
}
